import AvailabilityNotificationPopup from 'containers/MapDetails/popups/AvailabilityNotificationPopup'
import { getPlaceDetails, selectPlaceData, selectPlaceStatus } from 'containers/MapDetails/placeSlice'
import { addItemToBasket, BASKET_TYPES, extendFormToMap } from 'containers/OrderDetails/basketSlice'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import DetailsPopup from 'containers/MapDetails/popups/DetailsPopup'
import MagElement from 'containers/MapDetails/MagElement'
import { useDispatch, useSelector } from 'react-redux'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import { useEffect, useState } from 'react'
import Loading from 'components/Loading'
import { STATUS } from 'utils/constants'
import { v7 } from 'uuid'
import './style.scss'

const ObjectMags = () => {
  const { warehouses, sizes, displayOptions, ...place } = useSelector(selectPlaceData)
  const [dimensionsState, setDimensionsState] = useState({})
  const [expandedState, setExpandedState] = useState({})
  const { placeId: placeIdParams } = useParams()
  const status = useSelector(selectPlaceStatus)
  const { popup, openPopup } = usePopupState()
  const { state } = useLocation()

  const dispatch = useDispatch()
  const { push, replace } = useHistory()
  const { t } = useTranslation('mapDetails')

  const succeed = status === STATUS.succeed

  useEffect(() => {
    dispatch(getPlaceDetails(placeIdParams))
  }, [placeIdParams, dispatch])

  useEffect(() => {
    const isUnlocked = (state && typeof state === 'object' && 'unlock' in state) ? state.unlock : undefined
    if (isUnlocked) {
      replace(window.location.pathname + window.location.search)
    }
  }, [replace, state])

  const toggleDimensions = (index) => {
    setDimensionsState((prev) => ({
      ...prev,
      [index]: !prev[index],
    }))
  }

  const toggleExpanded = (index) => {
    setExpandedState((prev) => ({
      ...prev,
      [index]: !prev[index],
    }))
  }

  // const szukaneWarehouseTypeId = ''
  // const { selectedWarehouseType, restSizes } = sizes?.reduce((r, size) => {
  //   if (size.warehouseTypeId === szukaneWarehouseTypeId) {
  //     r.selectedWarehouseType = size
  //   } else {
  //     r.restSizes.push(size)
  //   }
  //   return r
  // }, { restSizes: [] })

  const addToBasketOrShowNextPage = (data, hash, date) => {
    if (displayOptions?.showMap || displayOptions?.listAllWarehouses) {
      push(`/placemap/${placeIdParams}?warehouseTypeId=${data.data.warehouseTypeId}${hash ? `&hash=${hash}` : ''}`)

    } else {
      const identifier = v7();
      const { street, estateNumber, localNumber, city, province, gpslatitude, gpslongitude } = place
      const { hasOnlineAccess, internalHeight, internalLength, internalWidth, area } = data?.data || {}

      dispatch(
        addItemToBasket({
          hash,
          identifier,
          type: BASKET_TYPES.rent,
          object: data?.data?.object,
          address: { street, estateNumber, localNumber, city, province, gpslatitude, gpslongitude },
          minDate: date ? date.replace(/(\d{2})\.(\d{2})\.(\d{4})/, '$3-$2-$1') : undefined,
          size: { internalHeight, internalLength, internalWidth, area },
          name: data.warehouseTypeName,
          placeId: placeIdParams,
          hasOnlineAccess,
        })
      )
      push(`/order/${identifier}`)
      dispatch(extendFormToMap(false))
    }
  }


  return (
    <div className='objectMags'>
      {popup?.type === 'details' && <DetailsPopup
        count={popup.body?.count}
        data={popup.body?.details}
      />}
      {popup?.type === 'availability' && <AvailabilityNotificationPopup
        placeId={placeIdParams}
        companyName={place.companyName}
        groupHash={popup.body?.groupHash}
        variantHash={popup.body?.variantHash}
        name={popup.body?.name}
      />}
      <div className='objectMags__list'>
        {succeed && sizes && warehouses
          ? sizes.map((item, idx) => {
            const currentWarehouses = warehouses[item.warehouseTypeId] || null
            const warehouseEntries = currentWarehouses
              ? Object.entries(currentWarehouses).sort(([, a], [, b]) => a.order - b.order)
              : []
            const isExpanded = expandedState[idx] || false
            const isOnlyOneChild = warehouseEntries.length === 1
            const firstHash = Object.keys(currentWarehouses)[0]
            const firstHashGroup = currentWarehouses[firstHash]
            const firstHashGroupForRentDates = Object.values(firstHashGroup?.for_rent || {})

            return (
              <div key={idx} className='objectMags__size'>
                <div className='head'>
                  <div className='left'>
                    <span>{item.name}</span>
                    <span>{item.size} m<sup>2</sup></span>
                  </div>
                  <div className='right'>
                    {isOnlyOneChild
                      ? `${item.monthlyGrossPrice} zł`
                      : `${t('from')} ${item.monthlyGrossPrice} zł`}
                  </div>
                </div>
                <div className='body'>
                  <div className='img'>
                    <div className='img__wraper'>
                      <img
                        src={dimensionsState[idx]
                          ? item.renders?.transparent
                          : item.renders?.default}
                        alt='Warehouse'
                      />
                    </div>
                    <div className='img__select'>
                      <span
                        className={!dimensionsState[idx] ? 'active' : ''}
                        onClick={() => toggleDimensions(idx)} >
                        {t('outside')}
                      </span>
                      <span
                        className={dimensionsState[idx] ? 'active' : ''}
                        onClick={() => toggleDimensions(idx)} >
                        {t('inside')}
                      </span>
                    </div>
                  </div>
                  <div className='desc'>
                    <div className='desc__top'>
                      {isOnlyOneChild && firstHashGroup?.attrs?.some(attr => attr.isImportant) && <div className='desc__important'>
                        <h4>{t('important')}</h4>
                        <div>
                          {firstHashGroup?.attrs?.map(({ key, name, isImportant }) => {
                            if (!isImportant) return null
                            return <div
                              key={key}
                              className='item'>
                              <i className={`icon icon--${key}-bold`} />
                              {name}
                            </div>
                          })}
                        </div>
                      </div>}
                      {isOnlyOneChild && firstHashGroup?.attrs?.some(attr => !attr.isImportant) && <div className='desc__attrs'>
                        <h4>{t('availableOptions')}</h4>
                        <div>
                          {firstHashGroup?.attrs?.map(({ key, name, isImportant }) => {
                            if (isImportant) return null
                            return <div
                              key={key}
                              className='item'>
                              <i className={`icon icon--${key}-bold`} />
                              {name}
                            </div>
                          })}
                        </div>
                      </div>}
                      <div className='desc__size'>
                        <h4>{t('internalDimensions')}</h4>
                        <span>
                          {Number(item.internalWidth)}m x {Number(item.internalHeight)}m x{' '}
                          {Number(item.internalLength)}m ({t('widthXHeightXLength')})
                        </span>
                      </div>
                      {item.fits && item.fits.length > 0 && <div className='desc__size'>
                        <h4>{t('youCanFitItHere')}:</h4>
                        <div>
                          {item.fits.map(({ name }, fitIdx) => (
                            <div key={fitIdx} className='element'>
                              <div className='iconWrapper'>
                                <i className='icon icon--check'></i>
                              </div>
                              <span>{name}</span>
                            </div>
                          ))}
                        </div>
                      </div>}
                    </div>
                    <div className='desc__btn'>
                      {isOnlyOneChild ? (
                        <button
                          className={`button --arrow${!firstHashGroup?.isAvailableForRentNow && firstHashGroupForRentDates.length === 0 ? ' --black' : ''}`}
                          onClick={() => {
                            if (firstHashGroup?.isAvailableForRentNow || firstHashGroupForRentDates.length > 0) {
                              const date = firstHashGroup?.isAvailableForRentNow ? null : firstHashGroupForRentDates[0]
                              addToBasketOrShowNextPage(firstHashGroup, firstHash, date)
                            } else {
                              openPopup({ type: 'availability', body: { name: `${firstHashGroup?.warehouseTypeName} - ${firstHashGroup?.name}`, groupHash: item.warehouseTypeId, variantHash: firstHash } })
                            }
                          }}>
                          <span className='--secFont'>
                            {firstHashGroup?.isAvailableForRentNow ? t('rent')
                              : firstHashGroupForRentDates.length > 0 ? `${t('rent')} ${t('from')} ${firstHashGroupForRentDates[0]}`
                                : t('notifyMeAboutAvailability')}
                          </span>
                          <svg xmlns="http://www.w3.org/2000/svg" width="8.174" height="8.879" viewBox="0 0 8.174 8.879"><g id="arrow-right" transform="translate(0.6 0.849)"><line id="Line_77" data-name="Line 77" x2="6.765" transform="translate(0 3.591)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2"></line><path id="Path_723" data-name="Path 723" d="M12,5l3.591,3.591L12,12.182" transform="translate(-8.617 -5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2"></path></g></svg>
                        </button>
                      ) : (
                        <button className={`button --arrow --drop ${isExpanded ? '--expanded' : ''}`} onClick={() => toggleExpanded(idx)}>
                          <span className='--secFont'>{t(isExpanded ? 'collapse' : 'expand')} {t('availableVariants')}</span>
                          <i className='icon icon--arrow-drop-down'></i>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                {isExpanded && warehouseEntries.length > 1 && (
                  <div className='objectMags__mags'>
                    {warehouseEntries.map(([hash, data]) => (
                      <MagElement
                        isDesktop
                        key={hash}
                        data={data}
                        openPopup={(type) => {
                          if (type === 'details') {
                            openPopup({ type: 'details', body: { details: data?.details, count: data?.free_now_to_rent_count } })
                          } else if (type === 'availability') {
                            openPopup({ type: 'availability', body: { name: `${data?.warehouseTypeName} - ${data?.name}`, groupHash: item.warehouseTypeId, variantHash: hash } })
                          }
                        }}
                        action={(date) => {
                          addToBasketOrShowNextPage(data, hash, date)
                        }}
                      />
                    ))}
                  </div>
                )}
              </div>
            )
          })
          : <Loading middleOfPage />}
      </div>
    </div>
  )
}

export default ObjectMags
